import React from 'react';
import styles from '../BaseSimplePage/BaseSimpleItemEditorFooter.module.css';
import {Divider} from "@mui/material";
import BaseSimpleItemEditorFooterButton from "../BaseSimplePage/BaseSimpleItemEditorFooterButton";

const WeightCoefficientsEditorFooter = ({onSaveBtnClick}) => {
    return (
        <div className={styles.main}>
            <Divider component="div"/>
            <div className={styles.buttonsArea}>
                <BaseSimpleItemEditorFooterButton
                    label="Сохранить"
                    onClick={onSaveBtnClick}
                />
            </div>
        </div>
    );
};

export default WeightCoefficientsEditorFooter;